import * as React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { inject } from 'mobx-react';
import { Layer } from 'bernie-view';
import { EGDSTertiaryButton } from '@egds/react-core/button';
import { EGDSDialog, EGDSDialogContent, EGDSDialogFooter } from '@egds/react-core/dialog';
import { EGDSEmptyState, EGDSEmptyStateActionArea } from '@egds/react-core/empty-state';
import { EGDSIcon } from '@egds/react-core/icons';
import { EGDSSpacing } from '@egds/react-core/spacing';
import { EGDSHeading, EGDSParagraph, EGDSText } from '@egds/react-core/text';
import { useLocalization } from '@shared-ui/localization-context';
import { handleLinkActionFromErrorMessage, handleRetry } from 'utils/error-handling-utils';
export const PackageError = inject('searchResults', 'analytics')(({
  searchResults,
  analytics
}) => {
  const errorResponse = searchResults === null || searchResults === void 0 ? void 0 : searchResults.errorResponse;
  const dialogErrorResponse = searchResults === null || searchResults === void 0 ? void 0 : searchResults.dialogErrorResponse;
  const history = useHistory();
  const location = useLocation();
  const onClickHandler = action => handleLinkActionFromErrorMessage(action, analytics, searchResults, history, location);
  const retryHandler = () => handleRetry(':errorOnSearch', 'MultiItem Retry Search', analytics, searchResults, history, location);
  if (dialogErrorResponse) {
    return React.createElement(DialogErrorResponse, {
      dialogErrorResponse: dialogErrorResponse,
      onClickHandler: onClickHandler
    });
  } else if (errorResponse) {
    return React.createElement(ErrorFromErrorResponse, {
      errorResponse: errorResponse,
      onClickHandler: onClickHandler
    });
  }
  return React.createElement(GenericError, {
    retryHandler: retryHandler
  });
});
const ErrorFromErrorResponse = ({
  errorResponse,
  onClickHandler
}) => {
  var _a;
  const errorRecoveryButtons = ((_a = errorResponse.errorRecoveryButtons) === null || _a === void 0 ? void 0 : _a.length) ? React.createElement(EGDSEmptyStateActionArea, null, errorResponse.errorRecoveryButtons.map((error, index) => {
    var _a;
    return React.createElement(EGDSTertiaryButton, {
      key: (_a = error.primary) !== null && _a !== void 0 ? _a : index,
      name: "textonly",
      onClick: () => onClickHandler(error.action),
      type: "button"
    }, error.primary);
  })) : null;
  const defaultButton = React.createElement(EGDSEmptyStateActionArea, null, React.createElement(EGDSTertiaryButton, {
    name: "textonly",
    onClick: () => onClickHandler(errorResponse.button.action),
    type: "button"
  }, errorResponse.button.primary));
  return React.createElement(EGDSSpacing, {
    padding: {
      blockstart: 'three'
    }
  }, React.createElement("div", null, React.createElement(EGDSEmptyState, {
    "data-stid": 'multi-item-error-actions'
  }, React.createElement(EGDSIcon, {
    name: 'search'
  }), React.createElement(EGDSHeading, {
    tag: "h2"
  }, errorResponse.header), React.createElement(EGDSText, {
    size: 300,
    theme: "default"
  }, errorResponse.body), errorRecoveryButtons, defaultButton)));
};
const GenericError = ({
  retryHandler
}) => {
  const {
    formatText
  } = useLocalization();
  return React.createElement(EGDSSpacing, {
    padding: {
      blockstart: 'three'
    }
  }, React.createElement("div", null, React.createElement(EGDSEmptyState, {
    "data-stid": "multi-item-generic-error"
  }, React.createElement(EGDSIcon, {
    name: 'search'
  }), React.createElement(EGDSHeading, {
    tag: "h2"
  }, formatText('multiItem.searchResults.error.text')), React.createElement(EGDSText, {
    size: 300,
    theme: "default"
  }, formatText('multiItem.searchResults.tryAgain.text')), React.createElement(EGDSEmptyStateActionArea, null, React.createElement(EGDSTertiaryButton, {
    name: "textonly",
    onClick: retryHandler,
    type: "button"
  }, formatText('multiItem.searchResults.retryButton.label'))))));
};
const DialogErrorResponse = ({
  dialogErrorResponse,
  onClickHandler
}) => {
  const {
    body,
    button: {
      action,
      primary
    }
  } = dialogErrorResponse;
  const buttonOne = {
    onClick: () => onClickHandler(action),
    text: primary !== null && primary !== void 0 ? primary : '',
    type: 'tertiary'
  };
  return React.createElement(Layer, {
    id: 'dialog-Error-Response-Layer'
  }, React.createElement(EGDSDialog, {
    dialogShow: true,
    returnFocusOnClose: true
  }, React.createElement(EGDSDialogContent, null, React.createElement(EGDSParagraph, {
    size: 2
  }, body), React.createElement(EGDSDialogFooter, {
    buttonOne: buttonOne
  }))));
};